import { Component, OnInit, Input, AfterViewInit, SecurityContext } from '@angular/core'
import { ChtmModel } from './chtm.model'
import { DomSanitizer } from '@angular/platform-browser'
import { PageService } from '../../page/page.service'
import { ChtmService } from './chtm.service'
import { CmodalService } from '../cmodal/cmodal.service'
import { GlobService } from 'src/app/shared/glob.service'
import { AuthService } from '../../shared/auth.service'
import { AjaxService } from 'src/app/shared/ajax.service'
import { UtilService } from 'src/app/shared/util.service'

@Component({
  selector: 'app-chtm',
  templateUrl: './chtm.component.html'
})

export class ChtmComponent implements OnInit {
  @Input() model: ChtmModel
  @Input() ido: string
  @Input() dyn: any
  ctyp = 'chtm'
  // glob = glob
  // ajax = ajax
  // util = util

  constructor(public glob:GlobService, private util: UtilService, private pservice: PageService, private service: ChtmService, public cmodalService: CmodalService, private sanitizer: DomSanitizer, private authService: AuthService, private ajax: AjaxService) {
    service.components = pservice.components.chtms
  }

  ngOnInit() {
    this.pservice.components.chtms.push(this)
    // this.glob.comps.push(this)

    if (this.ido) {
      this.model = new ChtmModel()
      this.model.id = this.ido
    }
    // this.model.sjs = this.sanitizer.bypassSecurityTrustScript(this.model.js)
    // this.addScript()
    // this.addStyle()
  }

  ngAfterViewInit() {
    var thos = this
    if (this.ido)
      this.ajax.execute({
        url: 'chtm/chtms',
        data: { id: this.ido },
        success: (post) => {
          this.model = post.result[0]
          this.service.init(thos, this.model)
        }
      })
    else {
      this.service.init(thos, this.model)
    }

  }

  public addScript() {
    let node = document.createElement('script')
    node.type = 'text/javascript'
    node.charset = 'utf-8'
    node.innerText = this.model.js
    document.getElementsByTagName('head')[0].appendChild(node)
  }

  public addStyle() {
    let node = document.createElement('style')
    node.innerText = this.model.css
    document.getElementsByTagName('head')[0].appendChild(node)
  }
}
